import {types} from './types';

const initialState = {
    list: [],
    groups: {
        list: [],
        summ: 0
    },
    live: [],
}

export function creditReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LIST_CREDIT:
            return { ...state, list: action.payload};
        case types.SET_LIST_GROUPS:
            return { ...state, groups: action.payload}
        case types.SET_CREDIT_LIVE:
            return { ...state, live: action.payload}
        default:
            return state
    }
}